// extracted by css-extract-rspack-plugin
export default {"ModelIcon":"m4x09mmEogaLRWSy"};